"use strict";
/*
 * Created on 09 02 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SelloutTermination}.</p>
 *
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteReleaseTerminationConverter, _DataObjectConverter_);

  function SiteReleaseTerminationConverter() {
    _classCallCheck(this, SiteReleaseTerminationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationConverter).apply(this, arguments));
  }

  return SiteReleaseTerminationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteReleaseTerminationConverter = SiteReleaseTerminationConverter;